import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";

export const IT_SSO_REDIRECT_CONTROLLER = new InjectionToken<ISsoRedirectController>('IT_SSO_REDIRECT_CONTROLLER');

export interface ISsoRedirectController extends IController {

  handleInit(eventData: any): void;
}
